export const systemControls = [
  {
    name: "创建人",
    _cid: "creator",
    cid: "cid",
    _type: "text"
  },
  {
    name: "创建时间",
    _cid: "createAt",
    cid: "cat",
    _type: "text"
  },
  {
    name: "最后修改人",
    _cid: "updateUser",
    cid: "upid",
    _type: "text"
  },
  {
    name: "最后修改时间",
    _cid: "updateAt",
    cid: "uat",
    _type: "text"
  },
  {
    name: "负责人",
    _cid: "owner",
    cid: "oid",
    _type: "text"
  }
]
